import {
  Tooltip as TooltipRsuite,
  TooltipProps as TooltipPropsRsuite,
  Whisper as WhisperRsuite,
} from "rsuite";
import "./index.css";

interface TooltipProps extends TooltipPropsRsuite {
  htmlString: string;
}

export const Tooltip: React.FC<TooltipProps> = (props) => {
  const { htmlString, placement = "top", children, ...tooltipProps } = props;

  const tooltipContent = (
    <TooltipRsuite {...tooltipProps}>
      <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
      {children}
    </TooltipRsuite>
  );
  return (
    <WhisperRsuite
      placement={placement}
      trigger={["hover", "focus"]}
      speaker={tooltipContent}
    >
      <button className="tooltip-icon">
        <i className="fas fa-info-circle"></i>
      </button>
    </WhisperRsuite>
  );
};
